'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _NewSpotSearch = require('../NewSpotSearch');

var _NewSpotSearch2 = _interopRequireDefault(_NewSpotSearch);

var _SurflineLogo = require('../SurflineLogo');

var _SurflineLogo2 = _interopRequireDefault(_SurflineLogo);

var _SurflineWaterDrop = require('../SurflineWaterDrop');

var _SurflineWaterDrop2 = _interopRequireDefault(_SurflineWaterDrop);

var _UserAvatar = require('../UserAvatar');

var _UserAvatar2 = _interopRequireDefault(_UserAvatar);

var _NewsMenu = require('../NewsMenu');

var _NewsMenu2 = _interopRequireDefault(_NewsMenu);

var _UserMenu = require('../UserMenu');

var _UserMenu2 = _interopRequireDefault(_UserMenu);

var _CamsReportsMenu = require('../CamsReportsMenu');

var _CamsReportsMenu2 = _interopRequireDefault(_CamsReportsMenu);

var _ForecastsMenu = require('../ForecastsMenu');

var _ForecastsMenu2 = _interopRequireDefault(_ForecastsMenu);

var _FavoritesMenu = require('../FavoritesMenu');

var _FavoritesMenu2 = _interopRequireDefault(_FavoritesMenu);

var _NavigationItem = require('../NavigationItem');

var _NavigationItem2 = _interopRequireDefault(_NavigationItem);

var _CloseIcon = require('../CloseIcon');

var _CloseIcon2 = _interopRequireDefault(_CloseIcon);

var _navigationPropTypes = require('./navigationPropTypes');

var _favoritesPropType = require('../PropTypes/favoritesPropType');

var _favoritesPropType2 = _interopRequireDefault(_favoritesPropType);

var _windowPropType = require('../PropTypes/windowPropType');

var _windowPropType2 = _interopRequireDefault(_windowPropType);

var _settingsPropType = require('../PropTypes/settingsPropType');

var _settingsPropType2 = _interopRequireDefault(_settingsPropType);

var _defaultLinks = require('./defaultLinks.js');

var _trackSegmentEvent = require('../helpers/trackSegmentEvent');

var _trackSegmentEvent2 = _interopRequireDefault(_trackSegmentEvent);

var _isPremiumOrVip = require('../helpers/isPremiumOrVip');

var _isPremiumOrVip2 = _interopRequireDefault(_isPremiumOrVip);

var _getSignInHref = require('../helpers/getSignInHref');

var _getSignInHref2 = _interopRequireDefault(_getSignInHref);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var NewNavigationBar = function (_Component) {
  (0, _inherits3.default)(NewNavigationBar, _Component);

  function NewNavigationBar(props) {
    (0, _classCallCheck3.default)(this, NewNavigationBar);

    var _this = (0, _possibleConstructorReturn3.default)(this, (NewNavigationBar.__proto__ || (0, _getPrototypeOf2.default)(NewNavigationBar)).call(this, props));

    _this.setMenuState = function (menuType) {
      return function (stateUpdate) {
        return _this.setState((0, _defineProperty3.default)({}, menuType, (0, _extends3.default)({}, _this.state[menuType], stateUpdate)));
      };
    };

    _this.setMobileMenu = function (renderComponent, title) {
      if (_this.state.viewport === 'mobile') {
        _this.setState({
          renderMobileMenu: renderComponent,
          mobileMenuTitle: title
        });
        document.body.style.position = 'fixed';
        document.documentElement.style.overflow = 'hidden';
      }
    };

    _this.removeMobileMenu = function () {
      _this.setState({
        renderMobileMenu: null
      });
      document.body.style.position = 'relative';
      document.documentElement.style.overflow = 'visible';
    };

    _this.handleClickCTA = function () {
      var window = _this.props.window;

      if (window && window.analytics) {
        window.analytics.track('Clicked Subscribe CTA', {
          ctaLocation: 'button top'
        });
      }
    };

    _this.resizeListener = function () {
      if (_this.resizeTimeout) return;
      _this.resizeTimeout = setTimeout(function () {
        _this.resizeTimeout = null;
        _this.updateScrollLock();
      }, 66);

      var _this$state = _this.state,
          viewport = _this$state.viewport,
          mobileBreakpoint = _this$state.mobileBreakpoint;

      if (viewport === 'mobile' && window.innerWidth > mobileBreakpoint) {
        _this.setState({ viewport: 'desktop' });
      } else if (viewport === 'desktop' && window.innerWidth <= mobileBreakpoint) {
        _this.setState({ viewport: 'mobile' });
      }
    };

    _this.scrollMenuToTop = function () {
      if (_this.mobileMenuRef) {
        _this.mobileMenuRef.scrollTop = 0;
      }
    };

    _this.updateScrollLock = function () {
      if (_this.state.renderMobileMenu && window.innerWidth > 768) {
        _this.removeMobileMenu();
      }
    };

    _this.handleClickedLink = function (clickProperties, closeMobileMenu) {
      if (clickProperties) {
        var name = clickProperties.name,
            properties = clickProperties.properties;

        (0, _trackSegmentEvent2.default)(name, properties);
      }
      if (closeMobileMenu) {
        _this.removeMobileMenu();
      }
    };

    _this.signInUrl = function () {
      var window = _this.props.window;

      return (0, _getSignInHref2.default)(window ? window.location.href : null);
    };

    _this.renderCamsReportsMenu = function () {
      var camsReportsMenuState = _this.state.camsReportsMenuState;
      var _this$props = _this.props,
          user = _this$props.user,
          settings = _this$props.settings,
          serviceConfig = _this$props.serviceConfig;

      return _react2.default.createElement(_CamsReportsMenu2.default, {
        loggedIn: !!user,
        navigationSettings: settings && settings.navigation,
        recentlyVisited: settings && settings.recentlyVisited && settings.recentlyVisited.spots,
        serviceConfig: serviceConfig,
        menuState: camsReportsMenuState,
        setMenuState: _this.setMenuState('camsReportsMenuState'),
        scrollMenuToTop: _this.scrollMenuToTop,
        signInUrl: _this.signInUrl(),
        onClickLink: _this.handleClickedLink
      });
    };

    _this.renderForecastsMenu = function () {
      var forecastsMenuState = _this.state.forecastsMenuState;
      var _this$props2 = _this.props,
          user = _this$props2.user,
          settings = _this$props2.settings,
          serviceConfig = _this$props2.serviceConfig;

      return _react2.default.createElement(_ForecastsMenu2.default, {
        loggedIn: !!user,
        navigationSettings: settings && settings.navigation,
        recentlyVisited: settings && settings.recentlyVisited && settings.recentlyVisited.subregions,
        serviceConfig: serviceConfig,
        menuState: forecastsMenuState,
        setMenuState: _this.setMenuState('forecastsMenuState'),
        scrollMenuToTop: _this.scrollMenuToTop,
        signInUrl: _this.signInUrl(),
        onClickLink: _this.handleClickedLink
      });
    };

    _this.renderFavoritesMenu = function () {
      var _this$props3 = _this.props,
          favorites = _this$props3.favorites,
          settings = _this$props3.settings,
          user = _this$props3.user;

      return _react2.default.createElement(_FavoritesMenu2.default, {
        favorites: favorites,
        settings: settings,
        user: user,
        onClickLink: function onClickLink(properties) {
          return _this.handleClickedLink(properties, true);
        }
      });
    };

    _this.renderNewsMenu = function () {
      return _react2.default.createElement(_NewsMenu2.default, {
        links: _defaultLinks.defaultNewsLinks,
        onClickLink: _this.handleClickedLink
      });
    };

    _this.renderUserMenu = function () {
      var _this$props4 = _this.props,
          user = _this$props4.user,
          entitlements = _this$props4.entitlements,
          serviceConfig = _this$props4.serviceConfig,
          freeTrialEligible = _this$props4.freeTrialEligible;

      return _react2.default.createElement(_UserMenu2.default, {
        user: user,
        links: _defaultLinks.defaultAccountLinks,
        entitlements: entitlements,
        freeTrialEligible: freeTrialEligible,
        serviceConfig: serviceConfig,
        showDetails: true,
        onClickLink: _this.handleClickedLink
      });
    };

    _this.state = {
      renderMobileMenu: null,
      mobileMenuTitle: null,
      viewport: null,
      mobileBreakpoint: 768,
      camsReportsMenuState: {
        loading: false,
        error: false,
        taxonomy: {
          parents: [],
          activeNode: {},
          children: []
        }
      },
      forecastsMenuState: {
        loading: false,
        error: false,
        taxonomy: {
          parents: [],
          activeNode: {},
          children: []
        }
      }
    };
    _this.mobileMenuRef = null;
    return _this;
  }

  (0, _createClass3.default)(NewNavigationBar, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      // eslint-disable-next-line react/no-did-mount-set-state
      this.setState({
        viewport: window.innerWidth > this.state.mobileBreakpoint ? 'desktop' : 'mobile'
      });
      window.addEventListener('resize', this.resizeListener);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.resizeListener);
      this.removeMobileMenu();
    }
  }, {
    key: 'render',
    value: function render() {
      var _this2 = this;

      var _state = this.state,
          renderMobileMenu = _state.renderMobileMenu,
          mobileMenuTitle = _state.mobileMenuTitle;
      var _props = this.props,
          user = _props.user,
          entitlements = _props.entitlements,
          serviceConfig = _props.serviceConfig,
          hideCTA = _props.hideCTA,
          window = _props.window;


      var signInUrl = (0, _getSignInHref2.default)(window ? window.location.href : null);

      return _react2.default.createElement(
        'header',
        { className: 'quiver-new-navigation-bar' },
        _react2.default.createElement(
          'div',
          { className: 'quiver-new-navigation-bar__content' },
          _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__logo-desktop' },
            _react2.default.createElement(
              'a',
              { href: '/' },
              _react2.default.createElement(_SurflineLogo2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__logo-mobile' },
            _react2.default.createElement(
              'a',
              { href: '/' },
              _react2.default.createElement(_SurflineWaterDrop2.default, null)
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__navigation' },
            _react2.default.createElement(
              _NavigationItem2.default,
              { linkDisplay: 'Cams & Reports' },
              _react2.default.createElement(
                'div',
                { className: 'quiver-new-navigation-bar__menu-wrapper' },
                this.renderCamsReportsMenu()
              )
            ),
            _react2.default.createElement(
              _NavigationItem2.default,
              { linkDisplay: 'Forecasts' },
              _react2.default.createElement(
                'div',
                { className: 'quiver-new-navigation-bar__menu-wrapper' },
                this.renderForecastsMenu()
              )
            ),
            _react2.default.createElement(
              _NavigationItem2.default,
              { linkDisplay: 'News', href: '/surf-news' },
              _react2.default.createElement(
                'div',
                { className: 'quiver-new-navigation-bar__menu-wrapper' },
                this.renderNewsMenu()
              )
            )
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__search' },
            _react2.default.createElement(_NewSpotSearch2.default, { serviceConfig: serviceConfig })
          ),
          _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__cta' },
            !hideCTA && (!user || !(0, _isPremiumOrVip2.default)(entitlements)) ? _react2.default.createElement(
              'a',
              {
                className: 'quiver-new-navigation-bar__cta__link',
                onClick: function onClick() {
                  return _this2.handleClickedLink({
                    name: 'Clicked Subscribe CTA',
                    properties: { ctaLocation: 'button top' }
                  });
                },
                href: '/upgrade'
              },
              'Go Premium'
            ) : null
          ),
          user ? _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__account' },
            _react2.default.createElement(
              _NavigationItem2.default,
              {
                linkDisplay: _react2.default.createElement(_UserAvatar2.default, { entitlements: entitlements }),
                role: 'button',
                onClick: function onClick() {
                  return _this2.setMobileMenu(_this2.renderUserMenu, 'Account');
                },
                tabIndex: '0'
              },
              _react2.default.createElement(
                'div',
                { className: 'quiver-new-navigation-bar__menu-wrapper' },
                this.renderUserMenu()
              )
            )
          ) : _react2.default.createElement(
            'a',
            {
              href: signInUrl,
              className: 'quiver-new-navigation-bar__sign-in'
            },
            'Sign In'
          )
        ),
        _react2.default.createElement(
          'div',
          { className: 'quiver-new-navigation-bar__mobile' },
          _react2.default.createElement(
            'div',
            { className: 'quiver-new-navigation-bar__mobile__content' },
            _react2.default.createElement(
              'div',
              { className: 'quiver-new-navigation-bar__mobile__container' },
              _react2.default.createElement(
                'div',
                { className: 'quiver-new-navigation-bar__mobile__nav' },
                renderMobileMenu ? _react2.default.createElement(
                  'div',
                  {
                    ref: function ref(el) {
                      return _this2.mobileMenuRef = el;
                    },
                    className: 'quiver-new-navigation-bar__mobile__nav__menu'
                  },
                  _react2.default.createElement(
                    'div',
                    { className: 'quiver-new-navigation-bar__mobile__nav__menu__inner' },
                    _react2.default.createElement(
                      'a',
                      {
                        className: 'quiver-new-navigation-bar__mobile__nav__menu__close',
                        role: 'button',
                        tabIndex: '0',
                        onClick: function onClick() {
                          return _this2.handleClickedLink({
                            name: 'Clicked Main Nav',
                            properties: {
                              completion: false,
                              linkName: 'close',
                              tabName: mobileMenuTitle
                            }
                          }, true);
                        }
                      },
                      _react2.default.createElement('span', null),
                      _react2.default.createElement(
                        'span',
                        {
                          className: 'quiver-new-navigation-bar__mobile__nav__menu__close__title'
                        },
                        mobileMenuTitle
                      ),
                      _react2.default.createElement(_CloseIcon2.default, null)
                    ),
                    renderMobileMenu()
                  )
                ) : null,
                _react2.default.createElement(_NavigationItem2.default, {
                  linkDisplay: 'Cams',
                  role: 'button',
                  tabIndex: '0',
                  onClick: function onClick() {
                    return _this2.setMobileMenu(_this2.renderCamsReportsMenu, 'Cams');
                  }
                }),
                _react2.default.createElement(_NavigationItem2.default, {
                  linkDisplay: 'Forecasts',
                  role: 'button',
                  tabIndex: '0',
                  onClick: function onClick() {
                    return _this2.setMobileMenu(_this2.renderForecastsMenu, 'Forecasts');
                  }
                }),
                _react2.default.createElement(_NavigationItem2.default, {
                  linkDisplay: 'Favorites',
                  role: 'button',
                  tabIndex: '0',
                  onClick: function onClick() {
                    return _this2.setMobileMenu(_this2.renderFavoritesMenu, 'Favorites');
                  }
                }),
                _react2.default.createElement(_NavigationItem2.default, {
                  linkDisplay: 'News',
                  role: 'button',
                  tabIndex: '0',
                  onClick: function onClick() {
                    return _this2.setMobileMenu(_this2.renderNewsMenu, 'News');
                  }
                })
              )
            )
          )
        )
      );
    }
  }]);
  return NewNavigationBar;
}(_react.Component);

NewNavigationBar.propTypes = {
  user: _propTypes2.default.shape(_navigationPropTypes.userProptype),
  favorites: _favoritesPropType2.default,
  settings: _settingsPropType2.default,
  large: _propTypes2.default.bool,
  entitlements: _propTypes2.default.arrayOf(_propTypes2.default.string),
  freeTrialEligible: _propTypes2.default.bool,
  style: _propTypes2.default.object,
  badge: _propTypes2.default.node,
  smallNotification: _propTypes2.default.node,
  serviceConfig: _propTypes2.default.shape({
    serviceUrl: _propTypes2.default.string
  }),
  window: _windowPropType2.default,
  hideCTA: _propTypes2.default.bool
};
NewNavigationBar.defaultProps = {
  user: null,
  accountMenuLinks: [],
  entitlements: [],
  freeTrialEligible: false,
  smallNotification: null,
  favorites: [],
  settings: {},
  hideCTA: false
};
exports.default = NewNavigationBar;


//////////////////
// WEBPACK FOOTER
// ./~/@surfline/quiver-react/dist/NewNavigationBar/NewNavigationBar.js
// module id = 610
// module chunks = 11